import script from "./TransferPaymentMethod.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferPaymentMethod.vue?vue&type=script&lang=ts&setup=true"

import "./TransferPaymentMethod.vue?vue&type=style&index=0&id=38544649&lang=scss"

const __exports__ = script;

export default __exports__